import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as types from './draft-constants';
import * as actions from './draft-actions';

export function* doDeleteDraft(id) {
  try {
    yield call(callApi, {
      endpoint: `order/${id}`,
      options: {
        errorMessage: `Could not delete draft order ${id}`,
        method: 'DELETE',
      },
    });
  } catch (err) {
    yield put(actions.deleteDraftFailure(err));
  }
}

export function* deleteDraft(action) {
  try {
    const { id, url } = action.payload;
    yield call(callApi, {
      endpoint: url || `order/${id}`,
      options: {
        errorMessage: `Could not delete draft order ${id}`,
        method: 'DELETE',
      },
    });
    yield put(actions.deleteDraftSuccess());
  } catch (err) {
    yield put(actions.deleteDraftFailure(err));
  }
}

export function* deleteAllDrafts(action) {
  try {
    yield call(callApi, {
      endpoint: 'order/multi',
      options: {
        body: JSON.stringify(action.payload),
        errorMessage: 'Could not delete draft orders',
        method: 'DELETE',
      },
    });
    yield put(actions.deleteAllDraftsSuccess());
  } catch (err) {
    yield put(actions.deleteAllDraftsFailure(err));
  }
}

function* watchDeleteAllDrafts() {
  yield takeLatest(types.DELETE_ALL_DRAFTS_REQUEST, deleteAllDrafts);
}

function* watchDeleteDraft() {
  yield takeLatest(types.DELETE_DRAFT_REQUEST, deleteDraft);
}

export default [
  fork(watchDeleteDraft),
  fork(watchDeleteAllDrafts),
];
